/** Service Desk console: Field visits (C11 dispatch board, kalendaryo at listahan; C12 detalye ng visit), SD-S3-10. */
export const serviceVisits = {
  subtitle: "Ipadala ang mga engineer, tingnan ang buong buwan sa isang sulyap, at panatilihing walang laman ang pila ng hindi pa naka-iskedyul.",
  noOrganisation: "Walang organisasyon",
  windowText: "{{day}} · {{from}} hanggang {{to}}",
  actions: { schedule: "Mag-iskedyul ng visit" },
  orgTab: { viewAll: "Buksan sa Field visits", emptyTitle: "Walang field visit", emptyBody: "Lalabas dito ang mga visit na naka-iskedyul para sa organisasyong ito." },
  stats: {
    label: "Mga bilang ng visit",
    today: "Ngayon",
    todayHint: "mga visit sa board",
    week: "Linggong ito",
    weekHint: "Lunes hanggang Linggo",
    road: "Nasa daan",
    roadHint: "naipadala o nasa site ngayon",
    queue: "Hindi pa naka-iskedyul",
    queueHint: "naghihintay ng window",
  },
  tabs: { label: "Mga tanaw ng visit", dispatch: "Dispatch", calendar: "Kalendaryo", list: "Listahan" },
  status: {
    proposed: "Naghihintay ng window",
    scheduled: "Naka-iskedyul",
    dispatched: "Naipadala na",
    on_site: "Naka-check in",
    completed: "Tapos na",
    cannot_complete: "Hindi natapos",
    cancelled: "Kinansela",
    no_access: "Walang access",
  },
  flow: { scheduled: "Naka-iskedyul", dispatched: "Naipadala", on_site: "Naka-check in", completed: "Tapos na" },
  kind: { corrective: "Pagkukumpuni", pm: "Preventive maintenance", calibration: "Calibration", installation: "Installation", inspection: "Inspeksyon", training: "Training" },
  origin: { staff: "Inayos ng team", client: "Hiniling ng client", maintenance: "Mula sa maintenance plan" },
  error: { title: "Hindi ma-load ang mga field visit", body: "Tingnan ang koneksyon at subukan muli. Walang nabago." },
  errors: {
    visit_conflict: "May ibang visit na ang engineer sa window na iyon.",
    visit_transition: "Hindi pa magagawa ng visit ang galaw na iyon.",
    visit_needs_window: "Lagyan muna ng simula at katapusang oras ang visit.",
    visit_needs_engineer: "Pumili muna ng lead engineer bago i-iskedyul ang visit.",
    window_unavailable: "Nakuha na ang window na iyon. Pumili ng iba.",
    too_late_to_change: "Huli na para baguhin ang visit na ito.",
    report_locked: "Naisumite na ang ulat at hindi na mababago.",
    report_incomplete: "Hindi pa kumpleto ang ulat.",
    beyond_contract: "Lampas sa kontrata ang visit na ito.",
    visit_ended: "Tapos na ang visit na ito at hindi na mababago.",
    reason_needed: "Sabihin kung bakit (sapat na ang ilang salita).",
  },
  board: {
    label: "Dispatch board",
    loading: "Nilo-load ang dispatch board",
    dayGroup: "Araw",
    previousDay: "Nakaraang araw",
    nextDay: "Susunod na araw",
    today: "Ngayon",
    engineerFilter: "Engineer",
    allEngineers: "Lahat ng engineer",
    engineer: "Engineer",
    day: "Araw",
    time: "Oras ng simula",
    timeRange: "{{from}} hanggang {{to}}",
    hour: "Oras",
    booked: "{{percent}}% ang puno",
    free: "Libre buong araw",
    noEngineers: "Wala pang engineer na puwedeng gumawa ng visit. Bigyan ang isang miyembro ng team ng karapatang visits.perform para lumabas dito.",
    hint: "I-drag ang visit sa ibang engineer o oras, o gamitin ang Ilipat sa… sa visit. Sasabihan ang client pagkatapos mong kumpirmahin.",
    hintReadOnly: "Makikita mo ang board pero hindi mo ito mababago.",
    columnLabel: "{{name}}, {{day}}",
    dropLabel: "Araw ni {{name}}, i-drop dito ang visit",
    blockLabel: "{{number}}, {{organisation}}, {{from}} hanggang {{to}}, {{status}}",
    moveTo: "Ilipat ang {{number}} sa…",
    moveMenu: "Ilipat ang {{number}}",
    moveHeading: "Ilipat ang {{number}} sa…",
    move: "Ilipat",
    selected: "Napili ang {{number}}. Pumili ng engineer, araw at oras ng simula, saka pindutin ang Ilipat.",
    moveCancelled: "Kinansela ang paglipat ng {{number}}.",
    moved: "Nailipat ang {{number}} sa {{where}}. Nasabihan ang client.",
    confirmTitle: "I-reschedule ang {{number}}?",
    confirmWhere: "{{engineer}}, {{day}}, {{from}} hanggang {{to}}",
    confirmBody: "Ilipat sa {{where}}. Sasabihan ang contact ng client sa e-mail na may bagong calendar invite.",
    confirm: "I-reschedule at sabihan",
    noConflict: "Walang conflict para kay {{name}}.",
    conflict: "May conflict para kay {{name}}:",
  },
  availability: {
    title: "Sino ang libre sa susunod na {{count}} araw ng trabaho",
    hint: "Umaga 08:00 hanggang 12:00, hapon 13:00 hanggang 17:00. Pumili ng libreng kalahating araw para mag-iskedyul.",
    label: "Availability ng mga engineer",
    am: "AM",
    pm: "PM",
    freeFor: "Libre si {{name}} sa {{day}}, {{half}}",
    busyFor: "Abala si {{name}} sa {{day}}, {{half}}",
    schedule: "Mag-iskedyul kay {{name}} sa {{day}}, {{half}}",
    errorTitle: "Hindi ma-load ang availability",
  },
  queue: {
    title: "Pila ng hindi pa naka-iskedyul",
    emptyTitle: "Walang naghihintay",
    emptyBody: "May window na ang bawat hiniling na visit.",
    schedule: "I-iskedyul",
    scheduleOne: "I-iskedyul ang {{number}}",
    waitingClient: "Naghihintay na pumili ng window ang client",
    waitingEngineer: "Kailangan ng engineer at window",
  },
  calendar: {
    loading: "Nilo-load ang kalendaryo",
    monthGroup: "Buwan",
    previous: "Nakaraang buwan",
    next: "Susunod na buwan",
    thisMonth: "Buwang ito",
    openDay: "Buksan ang {{day}} sa dispatch board, {{count}} visit",
    more: "+{{count}} pa",
    agenda: "Agenda para sa {{month}}",
    emptyTitle: "Walang laman ngayong buwan",
    emptyBody: "Walang visit para sa mga filter na ito. Pumili ng ibang buwan o alisin ang filter.",
  },
  list: {
    label: "Mga field visit",
    loading: "Nilo-load ang mga visit",
    statusGroup: "Katayuan",
    chip: { all: "Lahat", scheduled: "Naka-iskedyul", dispatched: "Naipadala", proposed: "Naghihintay", completed: "Tapos na" },
    search: "Hanapin ang visit, ticket, organisasyon",
    searchLabel: "Maghanap ng mga visit",
    visit: "Visit",
    ticket: "Ticket",
    organisation: "Organisasyon",
    kind: "Uri",
    engineer: "Engineer",
    window: "Window",
    status: "Katayuan",
    noEngineer: "Wala pang engineer",
    clientChooses: "Pipili ang client",
    emptyTitle: "Walang naka-iskedyul na visit",
    emptyBody: "Mag-iskedyul ng unang visit mula sa isang ticket, o sa button sa itaas.",
    emptyFilteredTitle: "Walang tumutugmang visit",
    emptyFilteredBody: "Alisin ang isang filter para makita ang lahat ng visit.",
  },
  schedule: {
    title: "Mag-iskedyul ng visit",
    titleQueued: "I-iskedyul ang {{number}}",
    titleMove: "I-reschedule ang {{number}}",
    description: "Piliin ang ticket, ang engineer at ang window. Nag-a-update ang mga babala sa ibaba habang binabago mo ang form.",
    descriptionMove: "Sasabihan ang client tungkol sa bagong window.",
    ticket: "Ticket",
    ticketHint: "I-type ang numero ng ticket o ilang salita ng pamagat nito.",
    ticketPlaceholder: "TKT-10001 o bahagi ng pamagat",
    ticketResults: "Mga tumutugmang ticket",
    ticketNone: "Walang bukas na ticket na tumutugma.",
    ticketError: "Hindi mahanap ang mga ticket. Subukan muli.",
    changeTicket: "Palitan",
    kind: "Uri",
    engineer: "Engineer",
    engineerChoose: "Pumili ng engineer",
    theEngineer: "Ang engineer",
    site: "Site",
    siteAny: "Walang partikular na site",
    assets: "Kagamitan",
    assetsNone: "Walang nakarehistrong kagamitan ang organisasyong ito.",
    window: "Window",
    mode: { fixed: "Itakda ang window", client: "Hayaang pumili ang client (hanggang 3 window)", queue: "Magpasya mamaya (idagdag sa pila)" },
    date: "Petsa",
    start: "Simula",
    length: "Haba",
    lengthValue: "{{hours}} oras {{minutes}} min",
    clientHint: "Pipili ang client ng isa sa hanggang {{count}} window sa chat, portal o e-mail.",
    pickEngineerFirst: "Piliin muna ang engineer para makita ang bukas niyang mga window.",
    windowsLabel: "Mga bukas na window",
    windowsNone: "Walang bukas na window sa susunod na sampung araw ng trabaho para sa habang ito. Paikliin ang visit o pumili ng ibang engineer.",
    windowsError: "Hindi ma-load ang mga bukas na window. Subukan muli.",
    calendarUnavailable: "Hindi nabasa ang konektadong kalendaryo, kaya mga ibang visit lang ang pinaghambing.",
    chosen: "{{count}} sa 3 window ang napili",
    queueHint: "Maghihintay ang visit sa pila ng hindi pa naka-iskedyul hanggang may magbigay ng window.",
    prep: "Paalala sa client para sa paghahanda",
    prepHint: "Makikita sa visit na nakikita ng client.",
    sunday: "Lunes hanggang Sabado ang mga field visit. Pumili ng ibang araw.",
    afterHours: "Nagsisimula o nagtatapos ang visit sa labas ng 08:00 hanggang 17:00. Puwede mo pa rin itong i-iskedyul.",
    conflictTitle: "May conflict para kay {{name}}:",
    conflictVisit: "{{number}} mula {{from}} hanggang {{to}}",
    conflictCalendar: "abala ang kalendaryo mula {{from}} hanggang {{to}}",
    allowConflicts: "I-iskedyul pa rin (magiging double booked ang engineer)",
    free: "Libre si {{name}} sa {{day}} mula {{from}}.",
    covered: "Sakop ng {{contract}}. Mabibilang ang visit sa mga karapatan nito.",
    notCovered: "Walang aktibong kontratang sumasakop sa ticket na ito: may bayad ang visit maliban kung sakop ng warranty.",
    notify: "Nasabihan ang client tungkol sa {{when}}; sasabihan silang muli.",
    noWindow: "wala pang window",
    submit: "Mag-iskedyul ng visit",
    submitPropose: "Ialok ang mga window na ito",
    submitQueue: "Idagdag sa pila",
    submitQueued: "I-iskedyul ang visit",
    submitMove: "I-reschedule at sabihan",
    problems: {
      ticket: "Piliin ang ticket para sa visit na ito.",
      engineer: "Pumili ng engineer.",
      day: "Pumili ng petsa.",
      sunday: "Lunes hanggang Sabado ang mga field visit.",
      start: "Pumili ng oras ng simula.",
      duration: "Pumili ng haba mula 15 minuto hanggang 12 oras.",
      proposals: "Pumili ng kahit isang window na iaalok.",
      prep: "Hanggang {{max}} character lang ang paalala.",
      allowConflicts: "I-tick ang I-iskedyul pa rin para i-double book ang engineer.",
    },
    done: {
      scheduled: "Naka-iskedyul na ang {{number}}",
      rescheduled: "Na-reschedule ang {{number}} at nasabihan ang client",
      proposed: "Naialok na ang mga window para sa {{number}}",
      queued: "Naidagdag ang {{number}} sa pila",
    },
  },
  detail: {
    back: "Mga field visit",
    backToVisits: "Bumalik sa mga field visit",
    loading: "Nilo-load ang visit",
    notFoundTitle: "Hindi nakita ang visit",
    notFoundBody: "Maaaring natanggal ito, o mali ang link.",
    title: "{{kind}}: {{organisation}}",
    chargeable: "May bayad",
    noWindow: "Pipili ang client ng window",
    addToCalendar: "Idagdag sa kalendaryo",
    downloadReport: "I-download ang ulat",
    reportSaved: "Nai-save ang ulat",
    reschedule: "I-reschedule",
    schedule: "I-iskedyul",
    cancel: "Kanselahin ang visit",
    progress: "Progreso ng visit",
    step: { done: "tapos na", current: "kasalukuyang hakbang", pending: "hindi pa" },
    cancelled: "Kinansela ang visit na ito. Nasabihan ang client.",
    cancelledReason: "Kinansela ang visit na ito: {{reason}}",
    waitingClient: "Naghihintay na pumili ang client ng isa sa mga inalok na window (chat, portal o e-mail).",
    waitingWindow: "Wala pang window ang visit na ito. I-iskedyul ito, o mag-alok sa client ng hanggang tatlo.",
    proposals: "Mga iminungkahing window",
    proposalsHint: "Pipili ang client ng isa",
    noProposals: "Wala pang inalok na window.",
    option: "Opsyon {{n}}",
    chosen: "Napili",
    scheduleMyself: "Ako na ang mag-iiskedyul",
    details: "Detalye ng visit",
    window: "Window",
    crew: "Mga engineer",
    site: "Site",
    team: "Team",
    prep: "Paalala sa client para sa paghahanda",
    internal: "Mga panloob na tala",
    travel: "Mga tala sa biyahe",
    template: "Template ng checklist",
    rescheduled: "Na-reschedule",
    rescheduledCount_one: "{{count}} beses",
    rescheduledCount_other: "{{count}} beses",
    origin: "Pinagmulan",
    rescheduleRequested: "Humiling ang client na ilipat ang visit na ito.",
    rescheduleRequestedNote: "Humiling ang client na ilipat ang visit na ito: {{note}}",
    assets: "Kagamitan",
    noAssets: "Walang napiling kagamitan.",
    ticket: "Ticket",
    contract: "Epekto sa kontrata",
    noContract: "Walang kontratang sumasakop sa visit na ito.",
    parts: "Mga piyesa para sa visit na ito",
    noParts: "Walang naitalang piyesa.",
  },
  cancel: {
    title: "Kanselahin ang {{number}}?",
    body: "Sasabihan ang client at ang engineer, at babalik ang ticket sa dating katayuan nito.",
    reason: "Dahilan",
    problem: "Maglagay ng dahilang hindi bababa sa {{min}} character.",
    keep: "Panatilihin ang visit",
    confirm: "Kanselahin ang visit",
    done: "Kinansela ang {{number}} at nasabihan ang client",
  },
  consumption: {
    title: "Lampas sa kontrata ang {{number}}",
    body: "Mas marami ang nagamit ng visit na ito kaysa sa pinapayagan ng kontrata. Bilangin pa rin ito, o i-waive. Mananatili sa ledger ang dahilan sa alinmang paraan.",
    open: "Magpasya",
    choice: "Ano ang gagawin sa visit na ito",
    action: { count_anyway: "Bilangin pa rin", waive: "I-waive" },
    actionHint: { count_anyway: "Ibibilang ito sa kontrata kahit lampas na sa limitasyon at hindi na ito sisingilin.", waive: "Hindi ito isasama sa bilang at hindi sisingilin." },
    reason: "Dahilan",
    reasonHint: "Hindi bababa sa {{min}} character. Itatago ito sa ledger.",
    problem: "Maglagay ng dahilang hindi bababa sa {{min}} character.",
    confirm: "I-save ang desisyon",
    counted: "Nabilang ang {{number}} sa kontrata",
    waived: "Na-waive ang {{number}}",
    state: { none: "Walang karapatan sa kontratang naaangkop.", counted: "Nabilang sa kontrata.", waived: "Na-waive na may dahilan.", beyond_contract: "Lampas sa kontrata; naghihintay ng desisyon." },
  },
  report: {
    banner: { completed: "Tapos na ang visit.", cannot_complete: "Hindi natapos ng engineer ang visit na ito.", no_access: "Hindi nakapasok ang engineer." },
    bannerResolved: "Naayos na ang problema.",
    bannerFollowUp: "Kailangan ng follow-up.",
    work: "Gawa at natuklasan",
    checkIn: "Check-in",
    checkOut: "Check-out",
    onSite: "Sa site",
    performed: "Ginawa",
    findings: "Natuklasan",
    resolved: "Naayos na ang problema",
    yes: "Oo",
    followUp: "Kailangan ng follow-up",
    followUpNote: "Follow-up",
    measurements: "Mga sukat",
    measurement: "Sukat",
    value: "Halaga",
    noMeasurements: "Walang naitalang sukat.",
    checklist: "Checklist",
    noChecklist: "Walang checklist na ginamit sa visit na ito.",
    passed: "{{pass}} sa {{total}} ang pasado",
    result: { pass: "pasado", fail: "bagsak", na: "hindi naaangkop", none: "walang sagot" },
    parts: "Mga piyesang ginamit",
    noParts: "Walang piyesang ginamit.",
    part: "Piyesa",
    qty: "Dami",
    coverage: "Saklaw",
    coverageValue: { warranty: "Warranty", contract: "Kontrata", chargeable: "May bayad" },
    removedSerial: "Serial na tinanggal",
    newSerial: "Bagong serial",
    photos: "Mga larawan",
    noPhotos: "Walang kinunang larawan.",
    clientSees: "Nakikita ng client",
    time: "Oras sa site",
    timeError: "Hindi ma-load ang mga time entry.",
    noTime: "Walang time entry.",
    entry: "Entry",
    length: "Haba",
    who: "Sino",
    billable: "may bayad",
    activity: { remote: "Remote", travel: "Biyahe", on_site: "Sa site", admin: "Admin" },
    timeTotal: "{{total}} sa kabuuan, {{billable}} ang may bayad.",
    duration: "{{hours}} oras {{minutes}} min",
    signoff: "Pagtanggap ng client",
    signMethod: { drawn: "pinirmahan sa screen", typed: "na-type na pangalan" },
    notSigned: "Hindi pa napipirmahan.",
    signRequested: "Hiniling ang pagtanggap at naghihintay sa client.",
  },
} as const;
